export enum LocalStorageConsts {
  SIGNER_GUIDE_ACCEPTED = 'SIGNER_GUIDE_ACCEPTED',
  VIDEO_DEVICE = 'VIDEO_DEVICE',
}
